// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__xKggW","skeleton-shimmer":"skeleton_skeleton-shimmer__siDUB"};